import { loadState } from '@nextcloud/initial-state';
import { generateUrl } from '@nextcloud/router';
import queryString from 'query-string';
import Vue from 'vue';
import Router, { isNavigationFailure, NavigationFailureType } from 'vue-router';
import logger from '../services/logger.ts';
const view = loadState('files_sharing', 'view');
const sharingToken = loadState('files_sharing', 'sharingToken');
Vue.use(Router);
// Prevent router from throwing errors when we're already on the page we're trying to go to
const originalPush = Router.prototype.push;
Router.prototype.push = (function (...args) {
    if (args.length > 1) {
        return originalPush.call(this, ...args);
    }
    return originalPush.call(this, args[0]).catch(ignoreDuplicateNavigation);
});
const originalReplace = Router.prototype.replace;
Router.prototype.replace = (function (...args) {
    if (args.length > 1) {
        return originalReplace.call(this, ...args);
    }
    return originalReplace.call(this, args[0]).catch(ignoreDuplicateNavigation);
});
/**
 * Ignore duplicated- and redirected-navigation errors but forward real exceptions
 *
 * @param error The thrown error
 */
function ignoreDuplicateNavigation(error) {
    if (isNavigationFailure(error, NavigationFailureType.duplicated)
        || isNavigationFailure(error, NavigationFailureType.redirected)) {
        logger.debug('Ignoring duplicated/redirected navigation from vue-router', { error });
    }
    else {
        throw error;
    }
}
const router = new Router({
    mode: 'history',
    // if index.php is in the url AND we got this far, then it's working:
    // let's keep using index.php in the url
    base: generateUrl('/s'),
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            // Pretending we're using the default view
            redirect: { name: 'filelist', params: { view, token: sharingToken } },
        },
        {
            path: '/:token',
            name: 'filelist',
            props: true,
        },
    ],
    // Custom stringifyQuery to prevent encoding of slashes in the url
    stringifyQuery(query) {
        const result = queryString.stringify(query).replace(/%2F/gmi, '/');
        return result ? ('?' + result) : '';
    },
});
export default router;
